
export default function ProblemsSection() {
  const problems = [
    {
      icon: 'ri-file-shield-2-line',
      title: 'The Burden of Compliance Debt',
      problem: 'Most practices treat HIPAA as a once-a-year "check the box" event, leaving massive gaps in real-world security.',
      value: 'We transform compliance from a legal liability into an operational standard. We ensure your practice isn\'t just "compliant on paper," but actually defended against audits and data breaches.',
    },
    {
      icon: 'ri-mental-health-line',
      title: 'Clinical Burnout & Friction',
      problem: 'Slow logins, crashing EHRs, and clunky workflows frustrate providers and lead to "workarounds" that compromise security.',
      value: 'We optimize the "Last Mile" of care—making sure technology is invisible so clinicians can focus on patients, not passwords. We ensure employees are productive and empowered, not hindered by their tools.',
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'The "Single Point of Failure" Risk',
      problem: 'A single ransomware attack or hardware failure can shutter a clinic for days, resulting in lost revenue and patient harm.',
      value: 'We provide Business Continuity, not just backups. We ensure that even in a crisis, your practice stays operational and your reputation remains intact.',
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Executive Blind Spots (The CTO Role)',
      problem: 'Practice owners often make tech decisions in a vacuum without knowing the long-term cost or security implications.',
      value: 'We serve as your Fractional CTO. We align your technology spend with your business growth, ensuring every dollar spent reduces risk or increases efficiency.',
    },
  ];

  return (
    <section id="problems" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            The High-Stakes Challenges We Solve
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Healthcare providers face unique technology challenges that go far beyond basic IT support
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {problems.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center">
                  <i className={`${item.icon} text-red-500 text-2xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">{item.title}</h3>
              </div>

              <div className="space-y-4">
                <div>
                  <p className="text-xs uppercase tracking-wider text-gray-500 font-semibold mb-2">
                    THE PROBLEM
                  </p>
                  <p className="text-gray-700 leading-relaxed">{item.problem}</p>
                </div>

                <div className="border-t border-gray-200 pt-4">
                  <p className="text-xs uppercase tracking-wider text-[#e10708] font-semibold mb-2">
                    THE VALUE
                  </p>
                  <p className="text-gray-900 leading-relaxed font-medium">{item.value}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
